'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconButton = function (_View) {
    _inherits(IconButton, _View);

    function IconButton() {
        var _ret;

        _classCallCheck(this, IconButton);

        var _this = _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call(this));

        _this.template = _main2.default;

        _this._handleClick = function () {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var key = 'componentIconButtonAnimation' + new Date().getTime(),
                items = [].concat(_this.state.animation);

            items.push({ key: key });

            _this.setState({ animation: items });

            (function () {
                var timer = setTimeout(function () {
                    var items = _this.state.animation,
                        len = items.length,
                        newItems = [];

                    while (len--) {
                        if (items[len].key !== key) {
                            newItems.push(items[len]);
                        }
                    }

                    _this.setState({ animation: newItems });
                }, 1000);

                _this.animationTimers.push(timer);
            })(key);

            return _this;
        };

        _this.state = {
            animation: []
        };

        _this.animationTimers = [];

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(IconButton, [{
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(IconButton.prototype.__proto__ || Object.getPrototypeOf(IconButton.prototype), 'computeStyleHash', this).call(this) + String(this.props.rippleColor) + String(this.props.disabled);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _get(IconButton.prototype.__proto__ || Object.getPrototypeOf(IconButton.prototype), 'componentWillUnmount', this).call(this);
            var len = this.animationTimers.length;

            while (len--) {
                clearTimeout(this.animationTimers[len]);
            }

            return this;
        }
    }]);

    return IconButton;
}(_Component2.default);

IconButton.propTypes = {
    // any supported image or url
    icon: _propTypes2.default.any,
    rippleColor: _propTypes2.default.string.isRequired,
    ripple: _propTypes2.default.bool,
    iconFx: _propTypes2.default.bool,
    title: _propTypes2.default.string,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    disabled: _propTypes2.default.bool
};
IconButton.defaultProps = {
    ripple: true,
    // only for single color svg icons
    // adds filter fx for every state
    iconFx: true,
    width: 24,
    height: 24,
    rippleColor: '#000'
};
IconButton.displayName = 'IconButton';
exports.default = IconButton;